export default {
    data() {
        return {
            isLaptop: 0,
        };
    },

    mounted() {
        this.checkScreenSize(); // Check screen size initially

        window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
    },
    methods: {
        checkScreenSize() {
            this.isLaptop = window.innerWidth >= 1024 ? 1 : 2;
        },
    },
};